import React, { Component } from 'react';

// import Custom Componenets
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import API_URL, { Post, Delete, Get, JENIS_DESA, } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Datetime from 'react-datetime';

import ReactSelect from 'react-select';

const frmDex = {
	uuid: '',
	asal_tanah: '',
	nomor_sertifikat: '',
	luas: '',
	kelas: '',
	asli_milik_desa: "0",
	pemerintah: "0",
	prov: "0",
	kab_kota: "0",
	lain_lain: "0",
	tanggal_perolehan: new Date(),
	sawah: "0",
	tegal: "0",
	kebun: "0",
	tambak: "0",
	tanah_kering: "0",
	patok_tanda_batas_ada: "0",
	patok_tanda_batas_tidak: "0",
	papan_nama_ada: "0",
	papan_nama_tidak: "0",
	lokasi: "",
	peruntukan: "",
	mutasi: "",
	keterangan: '',
}

const dateFormat = require('dateformat');

class MenuA5 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			loading: false,
			loadingPreview: false,
			imagePreview: null,
			detailPreview: false,
			detailData: null,
			awal: '',
			sebelum: '',
			hal: [],
			setelah: '',
			akhir: '',
			dt: frmDex,
			judul: 'Tambah Tanah Kas ' + JENIS_DESA,
			textCari: '',
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			editMode: false
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	pagination = data => {
		// const data = this.state.pagination;
		//console.log(data);
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = "primary-custom";
				if (i === data.current_page) {
					warna = "danger";
				}
				hal.push(
					<a
						onClick={() => this.fetch({ page: i })}
						className={
							"btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
						}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelum = (
					<a
						onClick={() => this.fetch({ page: p })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{"<"}
					</a>
				);
			}
			if (n > 0) {
				setelah = (
					<a
						onClick={() => this.fetch({ page: n })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{">"}
					</a>
				);
			}
			awal = (
				<a
					onClick={() => this.fetch({ page: 1 })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{"<<"}
				</a>
			);
			akhir = (
				<a
					onClick={() => this.fetch({ page: data.last_page })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{">>"}
				</a>
			);
		}
		this.setState({ awal, sebelum, hal, setelah, akhir });
	};

	fetch = (params = {}) => {
		this.setState({ loading: true })
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
					link =
						"?page=" +
						Math.ceil(
							this.state.pagination.total / this.state.pagination.per_page
						);
					break;
				case ">":
					link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
					break;
				case "<":
					link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
					break;
				case "<<":
					link = "?page=1";
					break;
				default:
					link = "?page=" + params.page;
					break;
			}
		}

		// if (this.state.textCari === '') {
		// 	Get("tanah-kas-desa" + link, null, dtkat => {
		// 		// console.log(dtkat);

		// 		if (dtkat.results) {
		// 			this.setState({
		// 				data: dtkat.results.data,
		// 				pagination: dtkat.results,
		// 				loading: false
		// 			})
		// 			this.pagination(dtkat.results);
		// 		}

		// 	});
		// } else { // Jika pencarian
		Post("tanah-kas-desa" + link, null, {
			q: this.state.textCari
		}, dtkat => {
			if (dtkat.data.results) {
				console.log('masuk');
				this.setState({
					data: dtkat.data.results.data,
					pagination: dtkat.data.results,
					loading: false
				})
				this.pagination(dtkat.data.results);
			}

		});
		// }

	};

	// ================== simpan data ==================
	simpan = ((e) => {
		e.preventDefault();
		this.setState({ loadingPreview: true })

		let bodyData = this.state.dt
		bodyData = {
			...bodyData,
			tanggal_perolehan: dateFormat(bodyData.tanggal_perolehan, "yyyy-mm-dd"),
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyData.uuid === "") {
			psn = "tambah";
			resstat = 201;
			bodyData.uuid = null;
		} else {
			psn = "ubah";
			resstat = 200;
			metode = "update";
		}

		console.log(bodyData);

		Post('tanah-kas-desa/' + metode, bodyData.uuid, bodyData, res => {
			// console.log(res);
			if (res.status === resstat) {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "success",
					basicTitle: "Data Tanah Kas " + JENIS_DESA,
					pesanAlert: "Berhasil " + psn + " Data"
				});

				document.getElementById('form-data').reset()
				this.fetch();
				this.setState({
					dt: frmDex,
					status: {
						...this.state.status,
						form: false
					}
				})
			} else {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "danger",
					basicTitle: "Data Tanah Kas " + JENIS_DESA,
					pesanAlert: "Gagal " + psn + " Data"
				});
			}
		})

	});
	// ========================================================================

	bukaForm = () => {
		this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
	};

	tutupForm = () => {
		this.setState({
			formDisposisi: false,
			status: {
				...this.state.status,
				form: false,
			},
		})

		this.forceUpdate();
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data Tanah Kas " + JENIS_DESA,
			editMode: true
		})

		if (data) {
			this.setState({
				dt: {
					...this.state.dt,
					uuid: data.uuid,
					tanggal_perolehan: new Date(data.tanggal_perolehan),
					asal_tanah: data.asal_tanah,
					nomor_sertifikat: data.nomor_sertifikat,
					luas: data.luas,
					kelas: data.kelas,
					asli_milik_desa: data.asli_milik_desa,
					pemerintah: data.pemerintah,
					prov: data.prov,
					kab_kota: data.kab_kota,
					lain_lain: data.lain_lain,
					sawah: data.sawah,
					tegal: data.tegal,
					kebun: data.kebun,
					tambak: data.tambak,
					tanah_kering: data.tanah_kering,
					patok_tanda_batas_ada: data.patok_tanda_batas_ada,
					patok_tanda_batas_tidak: data.patok_tanda_batas_tidak,
					papan_nama_ada: data.papan_nama_ada,
					papan_nama_tidak: data.papan_nama_tidak,
					lokasi: data.lokasi,
					peruntukan: data.peruntukan,
					mutasi: data.mutasi,
					keterangan: data.keterangan,
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
	}

	cariData = (e) => {
		if (e.key === 'Enter') {
			let txt = e.target.value
			this.setState({
				textCari: txt.trim(),
				loading: true
			});
			setTimeout(
				function () {
					this.fetch();
				}.bind(this),
				500
			);
		}
	};

	downloadSurat = () => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";

		fetch(API_URL + 'tanah-kas-desa/cetak', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
			// .then((response) => response.blob())
			.then((response) => {
				if (response.status == 200) {
					return response.blob()
				}
				this.setState({
					loading: false,
					show: true,
					basicType: 'danger',
					basicTitle: 'Data Tanah Kas ' + JENIS_DESA,
					pesanAlert: 'Gagal cetak surat'
				});
				throw new Error('Something went wrong');
			})
			.then((blob) => {
				// Create blob link to download
				const url = window.URL.createObjectURL(
					new Blob([blob]),
				);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute(
					'download',
					`Tanah Kas ${JENIS_DESA}.pdf`,
				);

				// Append to html link element page
				document.body.appendChild(link);

				// Start download
				link.click();

				// Clean up and remove the link
				link.parentNode.removeChild(link);
				this.setState({
					loading: false,
				})
			})
			.catch((e) => {
				// console.log(e);
			})
			;
	}

	componentDidMount() {
		this.fetch()
		console.log(this.state.dt);
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
			{
				dataField: 'asal_tanah',
				text: 'ASAL TANAH KAS ' + JENIS_DESA,
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'nomor_sertifikat',
				text: 'NOMOR SERTIFIKAT',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'luas',
				text: 'LUAS (m)',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'kelas',
				text: 'KELAS',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'asli_milik_desa',
			// 	text: 'MILIK ' + JENIS_DESA,
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'pemerintah',
			// 	text: 'PEMERINTAH',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'prov',
			// 	text: 'Provinsi',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'kab_kota',
			// 	text: 'KAB/KOTA',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'lain_lain',
			// 	text: 'LAIN-LAIN',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'tanggal_perolehan',
				text: 'Tanggal Perolehan',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'sawah',
			// 	text: 'SAWAH',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'tegal',
			// 	text: 'TEGAL',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'kebun',
			// 	text: 'KEBUN',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'tambak',
			// 	text: 'TAMBAK',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'tanah_kering',
			// 	text: 'TANAH KERING',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'patok_tanda_batas_ada',
			// 	text: 'ADA PATOK TANDA BATAS',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'patok_tanda_batas_tidak',
			// 	text: 'TIDAK ADA PATOK TANDA BATAS',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'papan_nama_ada',
			// 	text: 'ADA PAPAN NAMA',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'papan_nama_tidak',
			// 	text: 'TIDAK ADA PAPAN NAMA',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'lokasi',
				text: 'LOKASI',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'peruntukan',
			// 	text: 'PERUNTUKAN',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'mutasi',
			// 	text: 'MUTASI',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			// {
			// 	dataField: 'keterangan',
			// 	text: 'KET.',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				formatter: function (cell, row) {
					return (
						<div style={{ minWidth: "61px" }}>
							<Button
								size="xs"
								color="success"
								className="btn-icon mr-2"
								onClick={() => this.ubahData(row)}
							// disabled={btnAksi}
							>
								<i className="fa fa-pencil"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="info"
								className="btn-icon mr-2"
								onClick={() => {
									this.setState({
										detailPreview: true,
										detailData: row
									})
								}}
							>
								<i className="fa fa-eye"></i>
							</Button>{" "}
							<Button
								size="xs"
								color="danger"
								className="btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlert
												showCancel
												confirmBtnText="Hapus"
												confirmBtnBsStyle="danger"
												cancelBtnBsStyle="success"
												type="danger"
												title="Yakin ingin hapus data ?"
												onCancel={this.hideAlert}
												onConfirm={() => {
													Delete('tanah-kas-desa/delete', row.uuid, (res) => {
														if (res === 200) {
															this.setState({
																show: true,
																basicType: 'success',
																basicTitle: 'Data Tanah Kas ' + JENIS_DESA,
																pesanAlert: 'Berhasil hapus data'
															});
															this.fetch()
														} else {
															this.setState({
																show: true,
																basicType: 'danger',
																basicTitle: 'Data Tanah Kas ' + JENIS_DESA,
																pesanAlert: 'Gagal hapus data'
															});
														}
														this.setState({ alert: null })
													})
												}}
											>
												Proses ini tidak dapat dibatalkan!
											</SweetAlert>
										)
									});
								}}
								disabled={this.state.status.btnAksi}
							>
								<i className="fa fa-trash"></i>
							</Button>
						</div>
					)
				}.bind(this)
			}
		]

		return (
			<div>
				{/* <Breadcrumb title="Data Tanah Kas  Desa" parent="Admin" /> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				<SweetAlert
					show={this.state.loadingPreview}
					showCancel={false}
					showConfirm={false}
				>
					<div align="center">
						{/* <h5 className="modal-title mb-3" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5> */}
						<img
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")}
							style={{
								borderRadius: "10px",
								width: '150px'
							}}
						/>
					</div>
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-header">
									<div className="row">
										<div className="col-sm-6 text-left">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="info"
												className="btn-icon mr-2"
												onClick={() => {
													this.setState({ loading: true })
													this.downloadSurat()
												}}
											>
												Cetak
											</Button>{" "}
											<Button
												size="sm"
												color="success"
												className="btn-square"
												onClick={() => {
													this.setState({
														judul: 'Tambah Tanah Kas ' + JENIS_DESA,
														dt: frmDex,
														tmpImages: ['kosong'],
														editMode: false,
														currentLocation: this.state.curStaticLocation
													});
													// document.getElementById('form-data').reset()
													this.bukaForm();
												}}
											>
												Tambah Data
											</Button>
										</div>
									</div>
								</div>

								<div className="card-body datatable-react custom-font-sm">
									{/* <div className="row">
										<div className="col-md-12"> */}
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../../../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<div className='row'>
											<div className="col-md-5 text-right">
												<input
													type="text"
													className="form-control"
													style={{ marginBottom: '15px' }}
													id="cariTable"
													placeholder="Cari berdasarkan asal tanah"
													defaultValue={this.state.textCari}
													onChange={(e) => {
														this.setState({ textCari: e.target.value })
													}}
													onKeyPress={this.cariData}
												/>
												<div className="clearBtnSearch" style={{ display: this.state.textCari !== '' ? 'inline' : '' }}>
													<span className='fa fa-close' style={{ fontSize: '1.3em', cursor: 'pointer' }} onClick={() => {
														this.setState({
															textCari: '',
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
														document.getElementById('cariTable').value = ''
													}} ></span>
												</div>
											</div>
											<div className="col-md-7" style={{ marginBottom: '15px' }}>
												<Button
													size="sm"
													color="info"
													className="btn-square"
													onClick={() => {
														this.setState({
															textCari: document.getElementById("cariTable").value,
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
													}}
												>
													<i className="fa fa-search"></i>
												</Button>
											</div>
											{data.length > 0 ? (
												<>
													<div className="col-md-12">
														<BootstrapTable
															keyField="id"
															data={data}
															columns={columns}
														/>
														<div className="pull-right text-white">
															{this.state.awal}
															{this.state.sebelum}
															{this.state.hal.map(dt => {
																return dt;
															})}
															{this.state.setelah}
															{this.state.akhir}
														</div>
													</div>
												</>
											) : (
												<div className="col-md-12">
													<h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
												</div>
											)}
										</div>
									)}
									{/* </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<Modal
					open={this.state.detailPreview ? true : false}
					onClose={() => {
						this.setState({ detailPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
				>
					<div className="modal-header">
						<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Detail Data Tanah Kas {JENIS_DESA}</h5>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-md-12">
								{this.state.detailData ? (
									<>
										<div className="table-responsive">
											<table className='detail-dokumen-administrasi'>
												<tbody>
													<tr>
														<th width="280">Asal Tanah Kas</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.asal_tanah}</span></td>
													</tr>
													<tr>
														<th width="280">Nomor Sertifikat</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.nomor_sertifikat}</span></td>
													</tr>
													<tr>
														<th width="280">Luas</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.luas}</span></td>
													</tr>
													<tr>
														<th width="280">Kelas Tanah Kas</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.kelas}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Perolehan Tanah Kas {JENIS_DESA} (M<sup>2</sup>)</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th><b>a. Asli Milik Desa</b></th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.asli_milik_desa}</span></td>
													</tr>
													<tr>
														<th><b>b. Bantuan</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th className='pl-4'>Pemerintah</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.pemerintah}</span></td>
													</tr>
													<tr>
														<th className='pl-4'>Provinsi</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.provinsi}</span></td>
													</tr>
													<tr>
														<th className='pl-4'>Kabupaten/ Kota</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.kab_kota}</span></td>
													</tr>
													<tr>
														<th><b>c. Lain-lain</b></th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.lain_lain}</span></td>
													</tr>
													<tr>
														<th>Tanggal Perolehan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tanggal_perolehan}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Jenis Tanah Kas {JENIS_DESA} (M<sup>2</sup>)</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Sawah</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.sawah}</span></td>
													</tr>
													<tr>
														<th>Tegal</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tegal}</span></td>
													</tr>
													<tr>
														<th>Kebun</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.kebun}</span></td>
													</tr>
													<tr>
														<th>Tambak / Kolam</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tambak}</span></td>
													</tr>
													<tr>
														<th>Tanah Kering / Darat</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.tanah_kering}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Patok Tanda Batas (M<sup>2</sup>)</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Ada</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.patok_tanda_batas_ada}</span></td>
													</tr>
													<tr>
														<th>Tidak Ada</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.patok_tanda_batas_tidak}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th><b>Papan Nama (M<sup>2</sup>)</b></th>
														<th></th>
														<th></th>
													</tr>
													<tr>
														<th>Ada</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.papan_nama_ada}</span></td>
													</tr>
													<tr>
														<th>Tidak Ada</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.papan_nama_tidak}</span></td>
													</tr>

													<tr style={{ borderTop: "1px solid black" }}>
														<th>Lokasi</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.lokasi}</span></td>
													</tr>
													<tr>
														<th>Peruntukan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.peruntukan}</span></td>
													</tr>
													<tr>
														<th>Mutasi</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.mutasi}</span></td>
													</tr>
													<tr>
														<th>Keterangan tambahan</th>
														<th width="50" className="text-center">:</th>
														<td><span>{this.state.detailData.keterangan}</span></td>
													</tr>
												</tbody>
											</table>
										</div>
									</>
								) : ''}
							</div>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.status.form}
					onClose={this.tutupForm}
					closeOnEsc={false}
					closeOnOverlayClick={false}
					styles={{ modal: { width: '60%', maxWidth: "unset" } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.simpan(e) }}>
						<input className="form-control" id="uuid" type="hidden" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid} />
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							{/* <input
								className="form-control"
								id="uuid"
								type="hidden"
								placeholder="UUID"
								defaultValue={this.state.dt.uuid}
								value={this.state.dt.uuid}
							/> */}

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Asal Tanah Kas {JENIS_DESA}</Label>
									<input
										className="form-control"
										id="asal_tanah"
										type="text"
										placeholder={"Masukkan asal tanah kas " + JENIS_DESA}
										defaultValue={this.state.dt.asal_tanah}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													asal_tanah: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Nomor sertifikat, atau buku Letter C, atau Persil</Label>
									<input
										className="form-control"
										id="nomor_sertifikat"
										type="text"
										placeholder={"Masukkan nomor sertifikat, atau buku Letter C, atau Persil"}
										defaultValue={this.state.dt.nomor_sertifikat}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													nomor_sertifikat: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Luas (m<sup>2</sup>)</Label>
									<input
										className="form-control"
										id="luas"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah kas " + JENIS_DESA + ". Misal : 7000"}
										defaultValue={this.state.dt.luas}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													luas: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Kelas Tanah Kas {JENIS_DESA}</Label>
									<input
										className="form-control"
										id="kelas"
										type="text"
										placeholder={`Masukkan kelas tanah kas ${JENIS_DESA} (SI, DI, dan sebagainya).`}
										defaultValue={this.state.dt.kelas}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													kelas: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Luas Perolehan Tanah Kas {JENIS_DESA} (m<sup>2</sup>)</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Asli Milik {JENIS_DESA}</Label>
									<input
										className="form-control"
										id="asli_milik_desa"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.asli_milik_desa}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													asli_milik_desa: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Pemerintah</Label>
									<input
										className="form-control"
										id="pemerintah"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.pemerintah}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													pemerintah: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Provinsi</Label>
									<input
										className="form-control"
										id="prov"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.prov}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													prov: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Kab/Kota</Label>
									<input
										className="form-control"
										id="kab_kota"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.kab_kota}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													kab_kota: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Lain-lain</Label>
									<input
										className="form-control"
										id="lain_lain"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.lain_lain}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													lain_lain: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tanggal Perolehan</Label>
									<Datetime
										inputProps={{
											"data-testid": "tanggal_perolehan",
											placeholder: 'Tanggal perolehan',
											required: true
										}}
										inputId="tanggal_perolehan"
										name="tanggal_perolehan"
										locale="id-ID"
										timeFormat={false}
										dateFormat="DD/MM/yyyy"
										closeOnTab={true}
										closeOnSelect={true}
										initialValue={this.state.dt.tanggal_perolehan}
										value={this.state.dt.tanggal_perolehan}
										onChange={e => {
											if (typeof e._isValid !== 'undefined') {
												let tgl = e.format('YYYY-MM-DD');
												this.setState({
													dt: {
														...this.state.dt,
														tanggal_perolehan: new Date(tgl)
													}
												})
											}
										}}
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Luas per jenis Tanah Kas {JENIS_DESA} (m<sup>2</sup>)</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Sawah</Label>
									<input
										className="form-control"
										id="sawah"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.sawah}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													sawah: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tegal</Label>
									<input
										className="form-control"
										id="tegal"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.tegal}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tegal: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Kebun</Label>
									<input
										className="form-control"
										id="kebun"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.kebun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													kebun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tambak/Kolam</Label>
									<input
										className="form-control"
										id="tambak"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.tambak}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tambak: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tanah kering/ darat</Label>
									<input
										className="form-control"
										id="tanah_kering"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.tanah_kering}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tanah_kering: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Luas Tanah berdasarkan patok tanda batas</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Ada</Label>
									<input
										className="form-control"
										id="patok_tanda_batas_ada"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.patok_tanda_batas_ada}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													patok_tanda_batas_ada: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tidak ada</Label>
									<input
										className="form-control"
										id="patok_tanda_batas_tidak"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.patok_tanda_batas_tidak}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													patok_tanda_batas_tidak: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<FormGroup className="row ml-0 mr-0 mb-2" style={{ backgroundColor: '#666666' }}>
								<Label
									className="col-sm-12 col-form-label text-white"
								>
									<b>Luas Tanah berdasarkan papan nama</b>
								</Label>
							</FormGroup>
							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Ada</Label>
									<input
										className="form-control"
										id="papan_nama_ada"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.papan_nama_ada}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													papan_nama_ada: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Tidak ada</Label>
									<input
										className="form-control"
										id="papan_nama_tidak"
										type="number"
										min={0}
										placeholder={"Masukkan luas tanah"}
										defaultValue={this.state.dt.papan_nama_tidak}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													papan_nama_tidak: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>

							<hr />

							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Lokasi tanah kas {JENIS_DESA}</Label>
									{/* <input
										className="form-control"
										id="lokasi"
										type="text"
										placeholder={"Masukkan lokasi tanah kas " + JENIS_DESA}
										defaultValue={this.state.dt.lokasi}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													lokasi: e.target.value
												}
											})
										}}
										required
									/> */}
									<textarea
										className='form-control'
										name="lokasi"
										id="lokasi"
										cols="30"
										placeholder={`Diisi dengan lokasi tanah kas ${JENIS_DESA}`}
										defaultValue={this.state.dt.lokasi}
										value={this.state.dt.lokasi}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													lokasi: e.target.value
												}
											})
										}}
										rows="3"
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Peruntukan/ pemanfaatan</Label>
									<textarea
										className='form-control'
										name="peruntukan"
										id="peruntukan"
										cols="30"
										placeholder={`Diisi sesuai peruntukan/pemanfaatan tanah kas ${JENIS_DESA}.`}
										defaultValue={this.state.dt.peruntukan}
										value={this.state.dt.peruntukan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													peruntukan: e.target.value
												}
											})
										}}
										rows="3"
										required
									/>
								</Col>
							</div>

							<div className="form-row">
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Mutasi</Label>
									<textarea
										className='form-control'
										name="mutasi"
										id="mutasi"
										cols="30"
										placeholder={`Diisi setiap terjadi mutasi tanah kas ${JENIS_DESA}`}
										defaultValue={this.state.dt.mutasi}
										value={this.state.dt.mutasi}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													mutasi: e.target.value
												}
											})
										}}
										rows="4"
										required
									/>
								</Col>
								<Col sm="12" className="mb-2">
									<Label htmlFor="validationCustom05">Keterangan</Label>
									<textarea
										className='form-control'
										name="keterangan"
										id="keterangan"
										cols="30"
										placeholder='Diisi dengan catatan-catatan lain yang dianggap perlu'
										defaultValue={this.state.dt.keterangan}
										value={this.state.dt.keterangan}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													keterangan: e.target.value
												}
											})
										}}
										rows="4"
										required
									/>
								</Col>
							</div>

							{/* <FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="nik"
								>
									Keterangan
								</Label>
								<Col sm="9">
									<textarea className='form-control' name="keterangan" id="keterangan" cols="30" placeholder='Diisi dengan catatan-catatan lain yang dianggap perlu.' defaultValue={this.state.dt.keterangan} rows="3" required />
								</Col>
							</FormGroup> */}

						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								disabled={this.state.status.btnForm}
								onClick={this.tutupForm}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>
								Simpan
							</button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

export default MenuA5;
